import { useReducedMotion } from 'framer-motion';

const EASE_OUT = [0.25, 0.1, 0.25, 1];

/**
 * Shared motion config respecting prefers-reduced-motion.
 * Returns the same tuned durations/easings used everywhere in the editor
 * chrome so we don't diverge between FormatChrome, LinkPanel, MentionList, etc.
 */
export default function useUiMotion() {
  const reduced = useReducedMotion();
  return {
    reduced,
    pop: reduced ? { duration: 0 } : { duration: 0.22, ease: EASE_OUT },
    fade: reduced ? { duration: 0 } : { duration: 0.18, ease: EASE_OUT },
    quick: reduced ? { duration: 0 } : { duration: 0.15, ease: EASE_OUT },
  };
}
